import {
  GET_SEND_STITCH_FIX_EDI_REQUEST,
  GET_SEND_STITCH_FIX_EDI_SUCCESS,
  GET_SEND_STITCH_FIX_EDI_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const sendStitchFixEdi = (token, values, customerId) => (dispatch) => {
  dispatch({ type: GET_SEND_STITCH_FIX_EDI_REQUEST });
  const newData = {
    values,
    customerId,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}create/sendStitchFixEdi`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {      
      return dispatch({
        type: GET_SEND_STITCH_FIX_EDI_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEND_STITCH_FIX_EDI_ERROR,
        payload: error,
      });
      throw error;
    });
};
